<template>
  <div class="index">
    <main class="content">
      <transition  name="fadeInDown" :appear="true">
        <div class="header-transition">
          <header class="header">
            <router-link :to="{ name: 'CorpClients' }" class="corp-link">Корпоративный клиент</router-link>
<!--            <img src="/static/img/icons/logo-promo.svg?v=0617" alt="Gold Apple" class="logo">-->
          </header>
          <div class="title-wrap">
        <div class="title">Волшебный подарок</div>
        <div class="subtitle">Подарочные карты позволяют преподнести подарок любимым, не выходя из дома.</div>
<!--            <div class="title">Сервис временно</div>-->
<!--            <div class="title">Недоступен</div>-->
<!--            <div class="subtitle">Ведутся технические работы, приносим извинения за временные неудобства</div>-->
          </div>
        </div>
      </transition>
      <transition name="fadeInDown" :appear="true">
      <div class="cards">
          <div class="cards-img-container">
            <img
              srcset="/static/img/pic/cards_x1.png?v202002 579w,
                /static/img/pic/cards_x2.png 1920w"
              sizes="(max-width: 579px) 579px,
                      (max-width: 1920px) 915px,
                      915px"

              alt="Подарочные карты" class="cards-img">
          </div>
      </div>
      </transition>
      <transition name="fadeInUp" :appear="true">
      <div class="offer-wrap">
        <router-link :to="{ name: 'SelectType' }" class="offer-btn">Купить подарочную карту</router-link>
<!--        <div class="offer-btn-disabled">Купить подарочную карту</div>-->
        <p class="offer-desc">
          Подарочную карту можно использовать полностью или частично при покупке товаров в парфюмерных супермаркетах Золотое Яблоко и в интернет-магазине <a href="https://goldapple.by" target="_blank">goldapple.by</a>
        </p>
      </div>
      </transition>
    </main>
  </div>
</template>

<script>
export default {
  name: 'index',
  data () {
    return {}
  }
}
</script>

<style scoped>
  .fadeInDown-enter-active {
    transition: all 0.55s ease-out;
    transition-delay: 0.45s;
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  .fadeInDown-enter-to {
    opacity: 1;
    transform: none;
  }
  .fadeInUp-enter-active {
    transition: all .65s ease-in-out;
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
  .fadeInUp-enter-to {
    opacity: 1;
    transform: none;
  }
  .offer-wrap {
    transition-delay: 0.45s;
  }
  .index {
    flex-grow: 1;
    color: #000;
    display: flex;
    flex-direction: column;
    padding-bottom: 20px;
    overflow: hidden;
  }

  .header-transition {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
  }
  .header {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 25px 25px 0;
    margin-bottom: 22px;
    min-height: 50px;
    position: relative;
  }
  .corp-link {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 13px;
    padding: 7px 27px 5px;
    position: absolute;
    top: 25px;
    right: 25px;
    background-color: #F2F212 !important;
    min-width: 237px;
    text-align: center;
    min-height: 28px;
    color: #000000;
    transition: background-color 0.3s ease;
  }
  .corp-link:hover,
  .corp-link:focus {
    background-color: #B4F202 !important;
  }

  .corp-link:active {
    background-color: #F2F212 !important;
  }
  .logo {
    max-width: 275px;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    /* margin: auto; */
  }
  .title-wrap{
    max-width: 646px;
    text-align: center;
    margin-bottom: 30px;
  }

  .title-wrap > .subtitle {
    max-width: 520px;
    margin: 0 auto;
  }

  .title {
    font: 700 89px/1 Bebas, sans-serif;
    text-transform: uppercase;
    color: #ffffff;
  }
  .subtitle {
    font-size: 17px;
    line-height: 1.2;
    color: #ffffff;
    opacity: 0.8;
  }
  .cards {
    will-change: transform, opacity;
    width: 80%;
    max-width: 1356px;
    margin-bottom: 59px;
    text-align: center;
    /* height: 50vh; */
  }
  .cards-img-container{
    position: relative;
    width: max-content;
    margin: 0 auto;
  }
  .cards-img {
    /*width: 100%;*/
    /*   max-height: 100%;
    max-width: 100%; */
    /*margin-left: 8px;*/
  }
  .offer-wrap {
    max-width: 520px;
    margin: 0 auto;
    text-align: center;
  }
  .offer-btn {
    display: inline-block;
    text-align: center;
    min-width: 360px;
    padding: 20px 15px 16px 15px;
    border-radius: 4px;
    overflow: hidden;
    background: #F2F212 !important;
    color: #000000;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease;

    font-size: 15px;
    line-height: 1.87;
    letter-spacing: 0.7px;
  }
  .offer-btn-disabled {
    display: inline-block;
    text-align: center;
    min-width: 360px;
    padding: 20px 15px 16px 15px;
    border-radius: 4px;
    overflow: hidden;
    background: #BDBDBD !important;
    color: #fff;
    text-transform: uppercase;
    font-weight: 700;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
    transition: background-color 0.3s ease;
    font-size: 15px;
    line-height: 1.87;
    letter-spacing: 0.7px;
  }
  .offer-btn:hover {
    background-color: #B4F202 !important;
    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  }
  .offer-btn:active {
    background-color: #F2F212 !important;
  }
  .offer-desc {
    font-size: 12px;
    line-height: 1.2;
    margin-bottom: 0;
    color: #ffffff;
    opacity: 0.7;
    font-weight: 500;
    text-align: center;
  }
  .offer-desc a:hover {
    opacity: 0.7;
  }
  .index {
    background-image: url('/static/img/bg/bg_desktop.jpg');
    background-size: cover;
    background-position: top;
    background-repeat: no-repeat;
  }

  @media screen and (max-width: 1536px) {
    .index {
      background-image: url('/static/img/bg/bg_hd.jpg');
    }
  }

  @media screen and (max-width: 1023px) {
    .index {
      background-image: url('/static/img/bg/bg_tablet.jpg');
    }
  }

  @media screen and (max-width: 767px) {
    .index {
      background-image: url('/static/img/bg/bg_mobile.jpg');
    }
  }

  @media
  only screen and (-webkit-min-device-pixel-ratio: 2)      and (min-width: 320px),
  only screen and (   min--moz-device-pixel-ratio: 2)      and (min-width: 320px),
  only screen and (     -o-min-device-pixel-ratio: 2/1)    and (min-width: 320px),
  only screen and (        min-device-pixel-ratio: 2)      and (min-width: 320px),
  only screen and (                min-resolution: 192dpi) and (min-width: 320px),
  only screen and (                min-resolution: 2dppx)  and (min-width: 320px) {

    .cards {
      display: flex;
      justify-content: center;
    }

    .cards-img-container {
      width: 100%;
      min-width: 579px;
    }

    .cards-img {
      /* margin-left: 8px; */
    }
  }

  @media screen and (max-width: 1023px) {
    .header {
      padding: 15px 20px 0;
      margin-bottom: 10px;
      flex-direction: column;
      align-items: center;
    }
    .corp-link {
      /*position: static;*/
      /*font-size: 12px;*/
      /*margin-bottom: 16px;*/
      /*background: none;*/
      /*padding: 4px 0 1px;*/
      /*border-radius: 0;*/
      /*border: none;*/
      /*border-bottom: 1px dashed #fff;*/
      position: static;
    }
    .corp-link:hover,
    .corp-link:focus {
      background: none;
    }
    .logo {
      max-width: 220px;
    }
    .title-wrap {
      margin-bottom: 12px;
    }

    .title-wrap > .subtitle {
      max-width: 300px;
      margin: 0 auto;
    }

    .title {
      font-size: 57px;
    }
    .subtitle {
      font-size: 16px;
      line-height: 1.12;
      max-width: 280px;
      margin: 3px auto;
    }
    .cards {
      width: 100%;
      margin-bottom: 55px;
    }
    .offer-wrap {
      padding: 0 20px;
    }
    .offer-btn {
      padding: 19px 15px 15px;
      font-size: 13px;
      min-width: 286px;
      width: 286px;
    }
    .offer-desc {
      margin-top: 5px;
    }
  }

  @media screen and (max-width: 821px) {
    .cards {
      display: flex;
      justify-content: center;
      margin-bottom: 20px;
    }
    .cards-img-container{
      width: 100%;
      min-width: 579px;

    }
    .cards-img-container img {
      width: 100%;
      max-width: 579px;
    }
    .header{
      align-items: center;
    }
    .corp-link{
        /*min-width: auto;*/
    }
    .offer-btn {
      padding-top: 14px;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }
    .header {
      margin-bottom: 29px;
      padding-top: 31px;
    }
    .cards-img {
      /* margin-left: 19px; */
    }
    .header-transition {
      margin-bottom: 0px;
    }
    .title {
      font-size: 42px;
    }
  }
</style>
